import React, { useEffect } from 'react';
import Layout from '../Layout2';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Safreimg from '../../safreeimg/safree_icon.png'



const Admin2Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/admin2') {
      const timer = setTimeout(() => {
        navigate('/admin2/dashboard');
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [location.pathname, navigate]);


  return (
    <div className='mylanding'>
      <Layout>
        {/* Conditional Rendering for Multiple Elements */}
        {location.pathname === '/admin2' && (
          <div className='welcomepage'>
            <img src={Safreimg} alt="" />
            <h1>Safree(Safe And Free)</h1>
            <p>Welcome to Organization Admin!</p>
            {/* <NavLink
              to="/admin2/dashboard"
              className={({ isActive }) => (isActive ? 'sidebar-link active' : 'sidebar-link')}
            >
              <button>Go TO Dashboard</button>
            </NavLink> */}
          </div>
        )}
      </Layout>
    </div>
  );
};

export default Admin2Dashboard;
